import { shallow } from "zustand/shallow";
import { TabsContentProps } from "./TabsContent.types";
import { TabsContentStakeholders } from "./TabsContentStakeholders/TabsContentStakeholders.component";
import {
  TabsContentActivities,
  TabsContentCommunity,
  TabsContentDetail,
  TabsContentDetailWatch,
  TabsContentEditions,
  ResourcesContent,
  TabsContentRelated,
  TabsContentExercises
} from "../../components";
import { TAB_ITEMS } from "../../consts";
import { useAuthStore, useCommunityClusterStore } from "../../stores";


export function TabsContent({
  contentActivities,
  contentEditions,
  contentLinks,
  currentLO,
  contentRelated,
  contentTools,
  exercises,
  isDetailPage,
  sharedPosts,
  setOpenModalEcm,
  tabType,
  titleEditions,
  currentTeachers,
  currentTutors,
  learningObjectTypology,
  ...props
}: TabsContentProps) {
  const enableCommunityFlag = useAuthStore(state => state.corporateInfo?.enable_community_flag && state.smartConfiguration?.funcCommunity);
  const availableClusters = useCommunityClusterStore((store) => store.availableClusters, shallow);
  const communityFlag = enableCommunityFlag === true && !!(availableClusters.find(({ is_share_enabled }) => is_share_enabled));

  switch (tabType) {
  case TAB_ITEMS.ACTIVITIES:
    return (
      contentActivities && currentLO ? (
        <TabsContentActivities
          contentActivities={ contentActivities }
          currentLO={ currentLO }
          setOpenModalEcm={ setOpenModalEcm }
          title = { currentLO?.title ?? "" }
          { ...props }
        />
      ) : null
    );

  case TAB_ITEMS.COMMUNITY:
    return (
      communityFlag  ? (
        <TabsContentCommunity
          loId={ currentLO?.id.toString() ?? "" }
          sharedPosts={ sharedPosts }
        />
      ) : null
    );

  case TAB_ITEMS.DETAIL:
    return (
      <>
        {
          (isDetailPage==true && currentLO) ? (
            <TabsContentDetail
              currentLO={ currentLO }
              currentTeachers={ currentTeachers }
              currentTutors={ currentTutors }
              isDetailsPage={ isDetailPage }
              learningObjectTypology={ learningObjectTypology }
              { ...props }
            />
          ) : null
        }
        {
          (isDetailPage === false && currentLO) ? (
            <TabsContentDetailWatch
              currentLO={ currentLO }
              isDetailsPage={ isDetailPage }
              { ...props }
            />
          ) : null
        }
      </>
    );

  case TAB_ITEMS.EDITIONS:
    return (
      contentEditions && titleEditions ? (
        <TabsContentEditions
          currentLO={ currentLO }
          currentTeachers={ currentTeachers }
          contentEditions={ contentEditions }
          titleEditions={ titleEditions }
          rootId={ props.rootId }
          courseId={ props.courseId }
          { ...props }
        />
      ) : null
    );

  case TAB_ITEMS.INSTRUMENTS:
    if (contentLinks && contentTools === undefined) {
      return (
        <ResourcesContent
          contentLinks={ contentLinks }
          contentTools={ contentTools }
          currentLO={ currentLO }
          { ...props }
        />
      );
    } else if (contentLinks === null && contentTools) {
      return (
        <ResourcesContent
          contentLinks={ contentLinks }
          contentTools={ contentTools }
          currentLO={ currentLO }
          { ...props }
        />
      );
    } else if (contentLinks && contentTools) {
      return (
        <ResourcesContent
          contentLinks={ contentLinks }
          contentTools={ contentTools }
          currentLO={ currentLO }
          { ...props }
        />
      );
    } else { return null }

  case TAB_ITEMS.RELATED:
    return (
      contentRelated ? (
        <TabsContentRelated
          contentRelated={ contentRelated }
          currentLO={ currentLO }
          { ...props }
        />
      ) : null
    );

  case TAB_ITEMS.EXERCISES:
    if(exercises && currentTeachers
    ){
      return (
        <TabsContentExercises
          teachers={ currentTeachers }
          exercises={ exercises }
        />
      );
    } else {
      return null;
    }

  case TAB_ITEMS.STAKEHOLDERS:
    if(currentLO?.stakeholders){
      return (
        <TabsContentStakeholders
          stakeholders={ currentLO.stakeholders }
        />
      );
    } else {
      return null;
    }
  default:
    return (
      <></>
    );
  }
}
